import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { pingPresence } from "./performanceTrackerApi";

const DEFAULT_PING_MS = 60 * 1000;

/**
 * Keeps last_seen_at fresh while the signed-in SPA is open.
 * Independent of the work tracker. Hidden tabs still ping.
 */
export function usePresencePing() {
  const { instance, accounts } = useMsal();
  const accountId = accounts?.[0]?.homeAccountId || accounts?.[0]?.localAccountId || "";
  const accountsRef = useRef(accounts);
  accountsRef.current = accounts;
  const stopRef = useRef(false);

  useEffect(() => {
    if (!accountId) return undefined;

    stopRef.current = false;
    let intervalMs = DEFAULT_PING_MS;
    let timerId = null;
    let cancelled = false;

    const schedule = () => {
      if (cancelled || stopRef.current) return;
      timerId = window.setTimeout(run, intervalMs);
    };

    const run = async () => {
      if (cancelled || stopRef.current) return;
      try {
        const data = await pingPresence(instance, accountsRef.current);
        const next = Number(data?.presencePingSeconds);
        if (Number.isFinite(next) && next > 0) {
          intervalMs = next * 1000;
        }
      } catch (err) {
        if (err?.status === 401 || err?.status === 403) {
          stopRef.current = true;
          return;
        }
      }
      schedule();
    };

    run();

    return () => {
      cancelled = true;
      if (timerId) window.clearTimeout(timerId);
    };
  }, [accountId, instance]);
}
